import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DivisionSummaryListing } from './Pages'

export const DivisionSummaryReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={DivisionSummaryListing} />
    </Fragment>
)